import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';

import {LeadDataAPI, CallerAPI, LeadAssignCallerAPI} from "./../../../API/Team/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";


const Lead = () =>{

    const [leads, setLeads] = useState([]);
    const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [dispositions, setDispositions] = useState([]);
    const [filterdisposition, setFilterDisposition] = useState(0);
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [callers, setCallers] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);

    const perpagedata = 15;


    useEffect(() => {

        //if(showleads)
        //{
            CallerAPI(setCallers);
            LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setDispositions, "", setIsLeadAssign);
        //}

    }, [currentPage, isleadassign]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleInputEmailFilter =(e) =>{

        setFilterEmail(e.target.value);
    }

    const handleFilterLeadStatus = (e) =>{
        setFilterDisposition(e.target.value);
    }

    const handleInputNameFilter = (e) =>{
        setFilterName(e.target.value);
    }

    const handleFilterLeads = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);

        const filterparams = new URLSearchParams();

        if(filtername)
        {
            filterparams.append('filtername', filtername);
        }

        if(filteremail)
        {
            filterparams.append('filteremail', filteremail);
        }

        if(filterdisposition)
        {
            filterparams.append('filterdisposition', filterdisposition);
        }

        if(currentPage)
        {
            filterparams.append('page', currentPage);
        }

        if(perpagedata)
        {
            filterparams.append('per_page', perpagedata);
        }

        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setDispositions, filterparams);
    }

    const handleLeadAssign = (e, leadid) =>{
        
        console.log('caller id===' + e.target.value);
        console.log('Lead id===' + leadid);

        const callerid = e.target.value;

        const params = {
                        'callerid': callerid,
                        'leadid': leadid
                    };

        LeadAssignCallerAPI(params, setIsLeadAssign);
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Leads</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="d-flex align-items-center flex-wrap kanban-filter">
                                <div className="date-filter dropdown me-2">
                                    <select className="form-select" name="leadstatus-filter" onChange={handleFilterLeadStatus}>
                                        <option value="">Select Disposition</option>
                                        {dispositions.map((dispositionlist) =>
                                            <option key={dispositionlist.id} value={dispositionlist.id}>{dispositionlist.name}</option>
                                        )}
                                                                                
                                    </select>
                                </div>
                                <div className="email-filter me-2">
                                    <input className="form-control" type="email" name="filteremail" onChange={handleInputEmailFilter} placeholder="Enter email" />
                                </div>

                                <div className="email-filter me-2">
                                    <input className="form-control" type="text" name="filtername" onChange={handleInputNameFilter} placeholder="Enter name" />
                                </div>
                                <div className="button-filter me-2">
                                    <button type="button" className="btn btn-primary" onClick={handleFilterLeads}>
                                        <i className="ti ti-search me-2"></i>Apply Filter
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">
                                                            
                                <div className="table-responsive">
                                    
                                    <table className="table" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>                                                
                                                <th>Location</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Source</th>
                                                <th>Lead Status</th>                                                
                                                <th>Lead Assign</th>
                                                <th>Updated Date</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="11">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (leads && leads.length > 0  ? 
                                                ( leads.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>
                                                            <td>
                                                                <Link to={`/team/lead-profile/${lead.id}`} class="">
                                                                    <i className="fa fa-pencil "></i>
                                                                </Link>										
                                                            </td>
                                                            <td>{lead.name}</td>
                                                            <td>{lead.email}</td>                                                         
                                                            <td>{lead.contact}</td> 
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>                                                        
                                                            <td>{lead.institute}</td>                                                        
                                                            <td>{lead.source}</td>                                                        
                                                            <td>
                                                                {lead.leadstatus ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                                :
                                                                    <span>-</span>
                                                                }
                                                            </td>
                                                            <td>
                                                                <select className="form-select" name="caller" value={lead.telecaller_id} onChange={(e) => handleLeadAssign(e, lead.id) }>
                                                                    <option value="">Select Caller</option>
                                                                    {callers.map((caller) =>
                                                                        (
                                                                            <option key={caller.id} value={caller.id}>{caller.name}</option>
                                                                            
                                                                        ))                                        
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td>
                                                                {lead.calleddate ?
                                                                    (moment(lead.created_at).format('DD-MM-YYYY h:mm'))
                                                                :
                                                                    (moment(lead.created_at).format('DD-MM-YYYY h:mm'))
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="11">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="pagination-section mt-3">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>
        <ToastContainer />

    </div>
    )
}

export default Lead;